import { NgModule } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterModule, RouterOutlet, Routes } from '@angular/router';
import { InventoryManagerLotModule } from '../entities/lot/lot.module';
import { InventoryManagerTransactionModule } from '../entities/transaction/transaction.module';
import { InventoryManagerComponent } from './inventory-manager.component';
import { LotComponent, LotDetailComponent, LotResolvePagingParams } from '../entities/lot';
import { TransactionResolvePagingParams } from '../entities/transaction/transaction.route';
import { TabRouteGuard } from './tab-route.guard';
import { TransactionComponent } from '../entities/transaction/transaction.component';
import { InventoryService } from '../shared/inventory/service/inventory.service';
import { BmsjHipsterSharedModule } from '../shared';
import { HelpLinkComponent } from '../shared/help-link/help-link.component';

export const INVENTORY_MANAGER_ROUTES: Routes = [
    {
        path: '',
        component: InventoryManagerComponent,
        children: [
            {
                path: 'lot',
                component: LotComponent,
                outlet: 'inventory-manager-outlet',
                resolve: {
                    'pagingParams': LotResolvePagingParams
                },
                data: {
                    pageTitle: 'inventoryManagerApp.lot.home.title'
                },
                canActivate: [TabRouteGuard]
            }, {
                path: 'lot/:lotId',
                component: LotDetailComponent,
                data: {
                    pageTitle: 'inventoryManagerApp.lot.home.title'
                },
            }, {
                path: 'transaction',
                component: TransactionComponent,
                outlet: 'inventory-manager-outlet',
                resolve: {
                    'pagingParams': TransactionResolvePagingParams
                },
                data: {
                    pageTitle: 'inventoryManagerApp.transaction.home.title'
                },
            }
        ]
    }
];


@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        RouterModule.forChild(INVENTORY_MANAGER_ROUTES),
        InventoryManagerLotModule,
        InventoryManagerTransactionModule,
        HelpLinkComponent,
        RouterLink,
        RouterLinkActive,
        RouterOutlet,
    ],
    declarations: [
        InventoryManagerComponent
    ],
    providers: [
        LotResolvePagingParams,
        TransactionResolvePagingParams,
        InventoryService,
        TabRouteGuard
    ],
})
export class InventoryManagerModule { }
